import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu as MenuIcon, X, Phone } from "lucide-react";
import { RESTAURANT } from "../data/site";

const LINKS = [
  ["Home", "#home"],
  ["Menu", "#menu"],
  ["Catering", "#catering"],
  ["Gallery", "#gallery"],
  ["About", "#about"],
  ["Reviews", "#reviews"],
  ["Contact", "#contact"],
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass py-3" : "bg-transparent py-6"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 md:px-10">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="Sri Dosa Express" className="h-10 w-auto md:h-12" />
          <span className="hidden font-serif text-lg tracking-wide text-white/90 sm:block">
            Sri Dosa <span className="italic text-gold">Express</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {LINKS.map(([label, href]) => (
            <a
              key={label}
              href={href}
              data-testid={`nav-link-${label.toLowerCase()}`}
              className="text-[12px] uppercase tracking-[0.22em] text-white/70 transition-colors duration-300 hover:text-gold"
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={RESTAURANT.phoneHref}
            data-testid="nav-call-button"
            className="btn-ghost hidden items-center gap-2 whitespace-nowrap rounded-full px-5 py-2.5 text-[12px] uppercase tracking-[0.18em] text-white/85 md:flex"
          >
            <Phone size={13} className="text-gold" /> {RESTAURANT.phone}
          </a>
          <a
            href="/order"
            data-testid="nav-order-button"
            className="btn-gold hidden rounded-full px-6 py-2.5 text-[12px] font-semibold uppercase tracking-[0.18em] md:block"
          >
            Order Online
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="glass rounded-full p-2.5 text-white lg:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <MenuIcon size={18} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-panel"
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="glass mx-4 mt-3 rounded-2xl p-6 lg:hidden"
          >
            {LINKS.map(([label, href]) => (
              <a
                key={label}
                href={href}
                data-testid={`nav-mobile-link-${label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="block border-b border-white/5 py-3.5 font-serif text-2xl text-white/85 transition-colors hover:text-gold"
              >
                {label}
              </a>
            ))}
            <a
              href="/order"
              data-testid="nav-mobile-order-button"
              onClick={() => setOpen(false)}
              className="btn-gold mt-5 block rounded-full py-3 text-center text-[13px] font-semibold uppercase tracking-[0.2em]"
            >
              Order Online
            </a>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
